import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ComparisonTable() {
  return <section className="py-14 bg-brand-darker relative border-t border-zinc-900" data-id="element-70">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-71">
        <FadeIn data-id="element-72">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-10 text-center uppercase tracking-tight" data-id="element-73">
            LO QUE CAMBIA EN TU PRÓXIMA SEMANA
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-74">
          <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden shadow-2xl" data-id="element-75">
            {/* Header */}
            <div className="grid grid-cols-2 border-b border-zinc-800" data-id="element-76">
              <div className="p-6 text-center bg-zinc-950/50" data-id="element-77">
                <span className="text-xl md:text-2xl font-bold text-brand-red flex items-center justify-center gap-2" data-id="element-78">
                  <span className="text-2xl" data-id="element-79">❌</span> Sin el Master Pack
                </span>
              </div>
              <div className="p-6 text-center bg-brand-green/5 border-l border-zinc-800" data-id="element-80">
                <span className="text-xl md:text-2xl font-bold text-brand-green flex items-center justify-center gap-2" data-id="element-81">
                  <span className="text-2xl" data-id="element-82">✅</span> Con el Master Pack
                </span>
              </div>
            </div>

            {/* Rows */}
            <div className="divide-y divide-zinc-800/50" data-id="element-83">
              {/* Row 1 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-84">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-85">
                  Buscás en Google 40 min y no encontrás nada útil
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-86">
                  Abrís el Tomo 1 y tenés la solución en 5 minutos
                </div>
              </div>

              {/* Row 2 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-87">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-88">
                  Llevás el monopatín al service y esperás 5 días
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-89">
                  Aplicás el protocolo en casa el mismo día
                </div>
              </div>

              {/* Row 3 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-90">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-91">
                  Pagás $40.000 por una reparación de 20 minutos
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-92">
                  Invertís una vez y tenés el sistema para siempre
                </div>
              </div>

              {/* Row 4 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-93">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-94">
                  El monopatín se vuelve a mojar y se quema
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-95">
                  El Tomo 3 protege la electrónica antes de que llueva
                </div>
              </div>

              {/* Row 5 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-96">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-97">
                  No sabés si el error es grave o leve
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-98">
                  El árbol de decisión te lo dice en 60 segundos
                </div>
              </div>

              {/* Row 6 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-99">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-100">
                  Dependés del service para moverte
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-101">
                  Tenés independencia real para manejar cualquier falla
                </div>
              </div>

              {/* Row 7 */}
              <div className="grid grid-cols-2 hover:bg-zinc-800/20 transition-colors" data-id="element-102">
                <div className="p-4 md:p-6 text-zinc-400 text-sm md:text-base border-r border-zinc-800/50" data-id="element-103">
                  Cambiás la batería antes de tiempo por malos hábitos
                </div>
                <div className="p-4 md:p-6 text-white font-medium text-sm md:text-base bg-brand-green/5" data-id="element-104">
                  El Tomo 5 duplica la vida útil de la batería
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}